import { useState } from 'react';
import produce from 'immer';

const useModal = (initialState, message, callback) => {
  const modalParams = {
    isOpen: initialState,
    message,
    onClick: callback,
  };

  const [modal, setModal] = useState(modalParams);

  const toogleModal = (callback) => {
    const newModalParams = produce(modal, (draft) => {
      draft.isOpen = !draft.isOpen;

      return draft;
    });

    setModal(newModalParams);
    callback();
  };

  const setParams = (initialState, message, callback) => {
    const newModalParams = produce(modal, (draft) => {
      draft.isOpen = initialState;
      draft.message = message;
      draft.onClick = callback;

      return draft;
    });

    setModal(newModalParams);
  };

  return { modal, toogleModal, setParams };
};

export default useModal;
